import React, { useEffect } from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import { Children } from 'neon-design-system';

const useStyles = makeStyles(() => createStyles({
	preventCopyPaste: {
		width: '100%',
		userSelect: 'none'
	}
}));

interface PreventCopyPasteProps {
	children: Children;
}

const addClassNameListener = (callback: (className: string) => void) => {
	const elem = document.body;
	let lastClassName = elem.className;
	return window.setInterval(() => {
		const className = elem.className;
		if (className !== lastClassName) {
			callback(className);
			lastClassName = className;
		}
	}, 10);
}

export const PreventCopyPaste = ({ children }: PreventCopyPasteProps) => {
	const classes = useStyles();

	useEffect(() => {
		const intervalId = addClassNameListener((className: string) => {
			// used mediumZoom classes
			if (className === 'medium-zoom--opened') {
				const background = document.getElementsByClassName('medium-zoom-overlay')[0];
				const image = document.getElementsByClassName('medium-zoom-image--opened')[0];
				background && background.addEventListener('contextmenu', event => event.preventDefault());
				image && image.addEventListener('contextmenu', event => event.preventDefault());
			}
		});

		return () => window.clearInterval(intervalId);
	}, []);

	return (
		<Box onContextMenu={e => e.preventDefault()} className={classes.preventCopyPaste}>{children}</Box>
	);
}

export default PreventCopyPaste;
